module.exports = "render(\n  React.createElement(\n    'h1', null, 'Hello, world!'\n  ),\n  mountNode\n)\n\n/*render(\n  React.createElement('div', null, [\n    React.createElement(\n      'h1', null, 'Hello, world!'\n    ),\n    React.createElement(\n      'img', {src: './assets/hello.gif'}\n    ),\n  ]),\n  mountNode\n)*/\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/04_hello_world/hello-working.example
// module id = 1479
// module chunks = 0